import { AbstractEntityMapper } from '@pf/shared-services';
import {
    AsnLineCreate,
    AsnLineDto,
    AsnLineRead,
    AsnLineSearchParams,
} from '../../entities/asn-line.dto';
import { Injectable } from '@angular/core';
import { PlatformWmsMapper } from '../platform-wms.mapper';
import { AsnLineMetadataMap } from './asn-line.mapping-profile';

@Injectable()
export class AsnLineMapper extends AbstractEntityMapper<
    AsnLineRead,
    AsnLineCreate,
    AsnLineDto,
    AsnLineSearchParams
> {
    constructor() {
        super(AsnLineDto, PlatformWmsMapper, AsnLineMetadataMap.symbols);
    }
}
